import React, { useEffect } from "react";
import Button from "../../../../common/ekedc-components/button/Button";
import CommonDialog from "../../../../common/components/dialog/CommonDialog";
import styles from "./not-eligible-modal.module.scss";

interface RecipientNotEligibleModalProps {
	onClose: () => void;
}

const CrossIcon: React.FC = () => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
		<path d="M5.5 5.5L16.5 16.5M16.5 5.5L5.5 16.5" stroke="var(--app-primary-text)" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

const REQUIREMENTS = [
	{
		title: "You are both on the same band",
		body: "Both meter must belong to the same electricity distribution band (e.g., both on Band A).",
	},
	{
		title: "You are both on the same tariff",
		body: "Both meters must share the same pricing and tariff plan",
	},
	{
		title: "The receiver's meter is supported",
		body: "The recipient's meter must be a compatible model supported for unit transfers.",
	},
];

export const RecipientNotEligibleModal: React.FC<RecipientNotEligibleModalProps> = ({ onClose }) => {
	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") onClose();
		};
		document.addEventListener("keydown", onKey);
		return () => document.removeEventListener("keydown", onKey);
	}, [onClose]);

	return (
		<CommonDialog onCloseDialog={onClose} noPadding={true} borderRadius="21.67px">
			<div className={styles.modal}>
				<header className={styles.toolbar}>
					<button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
						<CrossIcon />
					</button>
					<div className={styles.toolbarSpacer} />
				</header>

				<div className={styles.body}>
					<div className={styles.hero}>
						<span className={styles.sadFace} role="img" aria-label="Not eligible">🥺</span>
					</div>

					<div className={styles.intro}>
						<h2 className={styles.title}>Oops, Can't Send Units to This Meter</h2>
						<p className={styles.subtitle}>
							The recipient's meter isn't eligible to receive units right now. To proceed, please ensure:
						</p>
					</div>

					<hr className={styles.divider} />

					<ol className={styles.list}>
						{REQUIREMENTS.map((req, idx) => (
							<li key={req.title} className={styles.listItem}>
								<span className={styles.itemNumber}>{String(idx + 1).padStart(2, "0")}.</span>
								<div className={styles.itemMain}>
									<span className={styles.itemTitle}>{req.title}</span>
									<span className={styles.itemBody}>{req.body}</span>
								</div>
							</li>
						))}
					</ol>

					<hr className={styles.divider} />
				</div>

				<footer className={styles.footer}>
					<Button text="Okay" onClick={onClose} />
				</footer>
			</div>
		</CommonDialog>
	);
};

export default RecipientNotEligibleModal;
